import { Alert, Box, Button, Card, IconButton, Table, Typography } from '@mui/joy'
import React, { useState } from 'react'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { post, Token } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
function Status({ data, update }) {
    const [create, setcreate] = useState(false);
    const [tarifupdates, settarifupdates] = useState(false);
    const [leistungsbeschreiung, setleistungsbeschreibung] = useState(false);
    const [alert,setalert] = useState(false);
    const navigate = useNavigate();
    function send() {
        let body = {};
        body.token = Token.get();
        body.action = "prüfe_tarif";
        body.targetid = data.id;
        body.tarfiupdates = tarifupdates;
        body.leistungsbeschreibungne = leistungsbeschreiung;
        let response = post(body,"/tarife/edit_tarif");
        if(response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            update();
            setcreate(false);
            setalert(true);
        }

    }
    function del(stamp) {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.targetid = data.id;
        body.stamp = stamp;
                let response = post(body,"/tarife/edit_tarif");
        if(response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            update();
            setcreate(false);
            setalert(true);
        }
    }
    return (
        <>
            {
                alert && (
                    <Alert
                    sx={{mb: 5}}
                    variant="soft"
                    color="success"
                    startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                    endDecorator={
                        <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                        Schliesen
                        </Button>
                    }
                    >
                    Ihre änderungen wurden Erfolgreich gespeichert.
                    </Alert>
                )
            }
            {
                create && (
                    <Card variant='soft' sx={{ mb: 3 }}>
                        <Box>
                            <Typography level="title-md">Prüfeintrag hinzufügen</Typography>
                            <Typography>Was wurde geprüft ?</Typography>
                        </Box>
                        <FormControlLabel control={<Checkbox checked={tarifupdates} onChange={() => settarifupdates(!tarifupdates)} />} label="Tarifupdates" />
                        <FormControlLabel control={<Checkbox checked={leistungsbeschreiung} onChange={() => setleistungsbeschreibung(!leistungsbeschreiung)} />} label="Leistungsbeschreibungen" />
                        <Button sx={{ width: "15%" }} onClick={
                            () => send()
                        }>Prüfungseintrag erstellen</Button>
                    </Card>
                )
            }

            <Card variant='soft'>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <Box>
                        <Typography level="title-md">Tarifstatus</Typography>
                        <Typography>Rot markierte Felder erfordern eine Aktion!</Typography>
                    </Box>
                    {data && data.editperms && (
                        <Button sx={{ height: "5%" }} onClick={() => setcreate(!create)}>
                            Prüfungseintrag erstellen
                        </Button>
                    )}
                </Box>
                <Table>
                    <thead>
                        <th>Feld</th>
                        <th>Geprüft</th>
                        <th>Am</th>
                        <th>Von</th>
                    </thead>
                    <tbody>
                        <tr key={"tarifupdates"}>
                            <td>Tarifupdates</td>
                            <td>
                                {
                                    data && !data.tarifupdates.mustbegeprüft && (
                                        <IconButton sx={{ bgcolor: "#c8e6c9" }}>
                                            <CheckCircleOutlineOutlinedIcon />

                                        </IconButton>
                                    )
                                }
                                {
                                    data && data.tarifupdates.mustbegeprüft && (
                                        <IconButton sx={{ bgcolor: "#ffcdd2" }}>
                                            <NotInterestedOutlinedIcon />

                                        </IconButton>
                                    )
                                }
                            </td>
                            <td>{data.tarifupdates.lasttarifupdate.split(":")[0]}:{data.tarifupdates.lasttarifupdate.split(":")[1]}</td>
                            <td>{data.tarifupdates.prüfer}</td>
                        </tr>
                        <tr key={"leistungsbeschreibungsupdates"}>
                            <td>Leistungsbeschreibungen</td>
                            <td>
                                {
                                    data && !data.leistungsupdates.mustbegeprüft && (
                                        <IconButton sx={{ bgcolor: "#c8e6c9" }}>
                                            <CheckCircleOutlineOutlinedIcon />

                                        </IconButton>
                                    )
                                }
                                {
                                    data && data.leistungsupdates.mustbegeprüft && (
                                        <IconButton sx={{ bgcolor: "#ffcdd2" }}>
                                            <NotInterestedOutlinedIcon />

                                        </IconButton>
                                    )
                                }
                            </td>
                            <td>{data.leistungsupdates.lastaufleistungsbeschreibung.split(":")[0]}:{data.leistungsupdates.lastaufleistungsbeschreibung.split(":")[1]}</td>
                            <td>{data.leistungsupdates.prüfer}</td>
                        </tr>
                        <tr>
                            <td>Pflichtdateien</td>
                            <td>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    {
                                        data && data.dateienzuprüfen > data.dateiengeprüft && (
                                            <IconButton sx={{ bgcolor: "#ffcdd2" }}>
                                                <NotInterestedOutlinedIcon />

                                            </IconButton>
                                        )
                                    }
                                    {
                                        data && data.dateiengeprüft == data.dateienzuprüfen && (
                                            <IconButton sx={{ bgcolor: "#c8e6c9" }}>
                                                <CheckCircleOutlineOutlinedIcon />

                                            </IconButton>
                                        )
                                    }
                                    <Typography sx={{ ml: 1 }}>{data.dateiengeprüft}/{data.dateienzuprüfen}</Typography>
                                </Box>
                            </td>
                            <td></td>
                            <td></td>


                        </tr>

                    </tbody>

                </Table>

            </Card >
            <Card
                sx={{ mt: 10 }}
                variant='soft'
            >
                <Box>
                    <Typography level="title-md">Historie</Typography>
                    <Typography>die Prüfungseinträge und Historie zu Dateien sind in deren Prüfungshistorie enthalten</Typography>
                </Box>

                <Table>
                    <thead>
                        <th>Tarifupdates</th>
                        <th>Leistungsbeschreibung</th>
                        <th>Am</th>
                        <th>Von</th>
                        {data && data.editperms && (
                            <th>Bearbeiten</th>
                        )}
                    </thead>
                    <tbody>
                        {data && data.historypr.slice().sort((a, b) => b.stamp - a.stamp).map((item) => {
                            return (
                                <tr key={item.stamp}>
                                    <td>
                                        {item.tarifupdate ? (
                                            <IconButton sx={{ bgcolor: "#c8e6c9" }}>
                                                <CheckCircleOutlineOutlinedIcon />
                                            </IconButton>
                                        ) : (
                                            <IconButton sx={{ bgcolor: "#ffcdd2" }}>
                                                <NotInterestedOutlinedIcon />
                                            </IconButton>
                                        )
                                        }
                                    </td>
                                    <td>
                                        {item.leistungsbeschreibung ? (
                                            <IconButton sx={{ bgcolor: "#c8e6c9" }}>
                                                <CheckCircleOutlineOutlinedIcon />
                                            </IconButton>
                                        ) : (
                                            <IconButton sx={{ bgcolor: "#ffcdd2" }}>
                                                <NotInterestedOutlinedIcon />
                                            </IconButton>
                                        )
                                        }
                                    </td>
                                    <td>
                                        {item.date}
                                    </td>
                                    <td>
                                        {item.prüfer}
                                    </td>
                                    {data && data.editperms && (
                                        <td>
                                            <Button
                                                variant="soft"
                                                color="danger"
                                                startDecorator={<DeleteForeverOutlinedIcon />}
                                                onClick={() => del(item.stamp)}
                                            >
                                                Löschen
                                            </Button>

                                        </td>
                                    )}
                                </tr>


                            );



                        })}



                    </tbody>
                </Table>



            </Card>
        </>
    )
}

export default Status
